import React from 'react'
import { RotatingLines } from 'react-loader-spinner'
import animationData from '../../assets/lottie/oatrx-loader';
import Lottie from 'react-lottie-player';

export const Loader = () => {

	return (
		<RotatingLines
			strokeColor="white"
			strokeWidth="5"
			animationDuration="1.75"
			width="20"
			visible={true}
		/>
	)
}

export const ScrollLoader = () => {

	return (
		<RotatingLines
			strokeColor="black"
			strokeWidth="5"
			animationDuration="1.75"
			width="20"
			visible={true}
		/>
	)
}


export const SwitchPharmacyLoader = () => {

	return (
		<RotatingLines
			strokeColor="#282828"
			strokeWidth="5"
			animationDuration="0.5"
			width="35"
			visible={true}
		/>

	)
}

export const LoadingView = () => {
	return (
		<div>
			<Lottie
				loop
				play
				animationData={animationData}
				style={{ width: 100, height: 150 }}
			/>
		</div>
	);
}


export const LoadMoreData = () => {
	return (
		<div className='flex items-center justify-center mt-8 mb-4'>
			<div className="loader "></div>
		</div>
	)
}
